import PropTypes from 'prop-types';

const RightDrawerPropTypes = {
  dummyPropType: PropTypes.object,
  classes: PropTypes.object,
};

export default RightDrawerPropTypes;
